// extracted by mini-css-extract-plugin
export default {"menuTabs":"e5cgdPXEtuui9DsZIjUO__menuTabs___","menuTabItem":"CcAlol4LtrSacDckdmUy__menuTabItem___"};